<div class="flex flex--column">
  <div>
    <span
      *ngIf="oldEndpointDateTime"
      class="grey-700-text text-icon-disabled-text itinerary-endpoint-time strike-through mr-xxsmall-r"
    >
      {{ oldEndpointDateTime | finTime }}
      {{ oldEndpointDateTime | finDateFormat: 'WEEKDAY_SHORT' }}
    </span>
    <span class="bold-type itinerary-endpoint-time">
      {{ endpoint.dateTime | finTime }}
      {{ endpoint.dateTime | finDateFormat: 'WEEKDAY_SHORT' }}
    </span>
  </div>
  <div>
    <span
      *ngIf="locations && oldEndpointLocationCode"
      class="grey-700-text text-icon-disabled-text itinerary-endpoint-location strike-through mr-xxsmall-r"
    >
      {{ locations[oldEndpointLocationCode]?.name }}
      ({{ oldEndpointLocationCode }}),
      {{ locations[oldEndpointLocationCode]?.cityName }}
    </span>
    <span *ngIf="locations && endpoint" class="medium-type itinerary-endpoint-location">
      {{ locations[endpoint?.locationCode]?.name }}
      ({{ endpoint.locationCode }}),
      {{ locations[endpoint?.locationCode]?.cityName }}
    </span>
  </div>
</div>
